import React from "react";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";


function Careers() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
    <title>Join Our Team | Web & SEO Careers with Her Growth Co.</title>
    <meta
      name="description"
      content="We’re hiring! If you love branding, design, and empowering women in business, apply to join the Her Growth Co team."
    />
    <meta
      name="keywords"
      content="join a women-led creative agency, careers in digital for women, apply to Her Growth Co, remote jobs for brand strategists, work with visionary women, hiring creatives and marketers, jobs for purpose-driven women"
    />
    <div>
<NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
        Coming Soon
        </div>
        {/* <PastWork/> */}
        <Footer />
     
    </div>
    </main>
  );
}

export default Careers;
